import { createAction } from 'redux-actions';
import envInfo from '../Types/envInfo';

export const loadEnvInfo = createAction(envInfo.LOAD_ENVINFO);
export const loadEnvInfoSuccess = createAction(envInfo.LOAD_ENVINFO_SUCCESS);
export const loadEnvInfoFail = createAction(envInfo.LOAD_ENVINFO_FAIL);

